var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPermissions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4129 4.14063C11.4129 6.16421 9.77242 7.80465 7.74883 7.80465C5.72525 7.80465 4.08481 6.16421 4.08481 4.14063C4.08481 2.11705 5.72525 0.476608 7.74883 0.476608C9.77242 0.476608 11.4129 2.11705 11.4129 4.14063ZM7.48256 15.0436L7.48487 15.0438L7.48383 15.0527L7.48256 15.0436ZM7.48487 15.0438L7.73272 12.9267L12.6893 8.91053C12.0612 7.12936 12.5714 5.07007 14.1268 3.81938C16.0934 2.23193 18.9832 2.53441 20.5706 4.50099C22.1581 6.46757 21.8556 9.35737 19.889 10.9448C18.3428 12.1943 16.2151 12.2724 14.6123 11.2791L14.4021 11.4482L14.1753 13.5992L12.0243 13.3724L11.7975 15.5234L7.48487 15.0438ZM15.2265 8.82266C14.4374 7.83874 14.5834 6.38989 15.5674 5.60074C16.5513 4.8116 18.0001 4.95763 18.7893 5.94155C19.5784 6.92547 19.4324 8.37432 18.4485 9.16347C17.4645 9.95261 16.0157 9.80658 15.2265 8.82266ZM5.43157 13.3831L5.88041 11.6519L6.06361 10.9282L6.70482 10.5435L8.17959 9.64581C8.09929 9.64581 8.02144 9.64337 7.94601 9.64101H7.946C7.87515 9.6388 7.80645 9.63665 7.7399 9.63665C5.29417 9.63665 0.411865 10.8641 0.411865 13.3007V14.2167C0.411865 14.7205 0.824067 15.1327 1.32787 15.1327H4.97357L5.42241 13.3831H5.43157Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPermissions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_permissions.2aad86506c533b2b649c99469d8e9453.svg";